import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/partner_1_2x.png'
import _imports_1 from '@/assets/img/partner_2_2x.png'
import _imports_2 from '@/assets/img/partner_3_2x.png'
import _imports_3 from '@/assets/img/partner_4_2x.png'
import _imports_4 from '@/assets/img/product_image.png'
import _imports_5 from '@/assets/img/logo.png'
import _imports_6 from '@/assets/img/logo_3.png'
import _imports_7 from '@/assets/img/card.png'
import _imports_8 from '@/assets/img/done.svg'


const _hoisted_1 = { class: "startSection" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "mainBanner" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "bannerInfo" }
const _hoisted_7 = {
  class: "slogan font-prompt",
  style: {"font-size":"38px"}
}
const _hoisted_8 = { style: {"font-size":"18px"} }
const _hoisted_9 = { class: "in" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "icon-arrow" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("ul", { class: "partnersList" }, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: "partner"
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: "partner"
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_2,
      alt: "partner"
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_3,
      alt: "partner"
    })
  ])
], -1)
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "createLinkAnimation animated" }
const _hoisted_15 = { class: "animationWrapper animated" }
const _hoisted_16 = { class: "createLinkForm animated" }
const _hoisted_17 = { class: "headBlock" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "subtitle" }
const _hoisted_20 = { class: "formBlock" }
const _hoisted_21 = { class: "fieldWrap" }
const _hoisted_22 = { class: "fieldItem" }
const _hoisted_23 = { class: "inBlockType1" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "inWrap" }
const _hoisted_26 = { class: "input" }
const _hoisted_27 = { class: "typingText product animated" }
const _hoisted_28 = { class: "fieldItem" }
const _hoisted_29 = { class: "inBlockType1" }
const _hoisted_30 = { class: "label" }
const _hoisted_31 = { class: "inWrap" }
const _hoisted_32 = { class: "input" }
const _hoisted_33 = { class: "typingText sum animated" }
const _hoisted_34 = { class: "checkWrap" }
const _hoisted_35 = { class: "checkBtn" }
const _hoisted_36 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  name: "card",
  id: "card"
}, null, -1)
const _hoisted_37 = { for: "card" }
const _hoisted_38 = { class: "btnFillType2 full" }
const _hoisted_39 = { class: "createLinkCard animated" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: "product image"
  })
], -1)
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "info" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = { class: "cost" }
const _hoisted_45 = { class: "button" }
const _hoisted_46 = { class: "btnIconType7" }
const _hoisted_47 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: "logo",
  class: "icon"
}, null, -1)
const _hoisted_48 = { class: "text" }
const _hoisted_49 = { class: "btnIconType7 dark animated" }
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  alt: "logo",
  class: "icon"
}, null, -1)
const _hoisted_51 = { class: "text" }
const _hoisted_52 = { class: "createLinkPayForm animated" }
const _hoisted_53 = { class: "paymentForm" }
const _hoisted_54 = { class: "headBlock" }
const _hoisted_55 = {
  class: "formTitle",
  style: {"font-size":"18px"}
}
const _hoisted_56 = { class: "siteLogo2" }
const _hoisted_57 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: "logo"
}, null, -1)
const _hoisted_58 = { class: "data" }
const _hoisted_59 = { class: "subtitle" }
const _hoisted_60 = { class: "title" }
const _hoisted_61 = { class: "formBlock" }
const _hoisted_62 = { class: "fieldsWrap" }
const _hoisted_63 = { class: "fieldItem" }
const _hoisted_64 = { class: "col" }
const _hoisted_65 = { class: "inBlockType1" }
const _hoisted_66 = { class: "label" }
const _hoisted_67 = { class: "inWrap" }
const _hoisted_68 = { class: "input" }
const _hoisted_69 = { class: "fadingText animated" }
const _hoisted_70 = { class: "fieldItem" }
const _hoisted_71 = { class: "col" }
const _hoisted_72 = { class: "inBlockType1" }
const _hoisted_73 = { class: "label" }
const _hoisted_74 = { class: "inWrap comb" }
const _hoisted_75 = { class: "input" }
const _hoisted_76 = { class: "fadingText animated" }
const _hoisted_77 = { class: "input" }
const _hoisted_78 = { class: "fadingText animated" }
const _hoisted_79 = { class: "col" }
const _hoisted_80 = { class: "inBlockType1" }
const _hoisted_81 = { class: "label" }
const _hoisted_82 = { class: "inWrap" }
const _hoisted_83 = { class: "input" }
const _hoisted_84 = { class: "fadingText animated" }
const _hoisted_85 = { class: "btnFillType2 full upp" }
const _hoisted_86 = /*#__PURE__*/_createVNode("div", { class: "createLinkPayCard animated" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_7,
    alt: "card"
  })
], -1)
const _hoisted_87 = { class: "createLinkResult animated" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_8,
    alt: "done"
  })
], -1)
const _hoisted_89 = { class: "text" }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "overlay" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("slogan1")), 1),
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t("slogan2")), 1),
              _createVNode("a", {
                href: _ctx.registerUrl,
                class: "btnIconType1"
              }, [
                _createVNode("span", _hoisted_9, [
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.t("startSection.signup")), 1),
                  _hoisted_11
                ])
              ], 8, ["href"])
            ]),
            _hoisted_12
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t("startSection.createLinkForm.title")), 1),
                    _createVNode("span", _hoisted_19, _toDisplayString(_ctx.t("startSection.createLinkForm.subtitle")), 1)
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", _hoisted_23, [
                          _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t("startSection.createLinkForm.proServiceLabel")), 1),
                          _createVNode("div", _hoisted_25, [
                            _createVNode("div", _hoisted_26, [
                              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.t("startSection.createLinkForm.proServiceValue")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _createVNode("div", _hoisted_29, [
                          _createVNode("span", _hoisted_30, _toDisplayString(_ctx.t("startSection.createLinkForm.amountLabel")), 1),
                          _createVNode("div", _hoisted_31, [
                            _createVNode("div", _hoisted_32, [
                              _createVNode("span", _hoisted_33, _toDisplayString(_ctx.t("startSection.createLinkForm.amountValue")), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode("label", _hoisted_37, _toDisplayString(_ctx.t("startSection.createLinkForm.card")), 1)
                      ])
                    ]),
                    _createVNode("span", _hoisted_38, _toDisplayString(_ctx.t("startSection.createLinkForm.submit")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _createVNode("span", _hoisted_43, _toDisplayString(_ctx.t("startSection.createLinkCard.title")), 1),
                      _createVNode("span", _hoisted_44, _toDisplayString(_ctx.t("startSection.createLinkCard.cost")), 1)
                    ]),
                    _createVNode("div", _hoisted_45, [
                      _createVNode("button", _hoisted_46, [
                        _hoisted_47,
                        _createVNode("span", _hoisted_48, _toDisplayString(_ctx.t("startSection.createLinkCard.pay")), 1)
                      ]),
                      _createVNode("button", _hoisted_49, [
                        _hoisted_50,
                        _createVNode("span", _hoisted_51, _toDisplayString(_ctx.t("startSection.createLinkCard.pay")), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode("div", _hoisted_53, [
                    _createVNode("div", _hoisted_54, [
                      _createVNode("div", _hoisted_55, _toDisplayString(_ctx.t("startSection.createLinkPayForm.checkout")), 1),
                      _createVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createVNode("div", _hoisted_58, [
                          _createVNode("span", _hoisted_59, _toDisplayString(_ctx.t("startSection.createLinkPayForm.subTitle")), 1),
                          _createVNode("span", _hoisted_60, _toDisplayString(_ctx.t("startSection.createLinkPayForm.title")), 1)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _createVNode("div", _hoisted_63, [
                          _createVNode("div", _hoisted_64, [
                            _createVNode("div", _hoisted_65, [
                              _createVNode("span", _hoisted_66, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cardNoLabel")), 1),
                              _createVNode("div", _hoisted_67, [
                                _createVNode("div", _hoisted_68, [
                                  _createVNode("span", _hoisted_69, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cardNoValue")), 1)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_70, [
                          _createVNode("div", _hoisted_71, [
                            _createVNode("div", _hoisted_72, [
                              _createVNode("span", _hoisted_73, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateLabel")), 1),
                              _createVNode("div", _hoisted_74, [
                                _createVNode("div", _hoisted_75, [
                                  _createVNode("span", _hoisted_76, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateValue1")), 1)
                                ]),
                                _createVNode("div", _hoisted_77, [
                                  _createVNode("span", _hoisted_78, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateValue2")), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_79, [
                            _createVNode("div", _hoisted_80, [
                              _createVNode("span", _hoisted_81, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cvcLabel")), 1),
                              _createVNode("div", _hoisted_82, [
                                _createVNode("div", _hoisted_83, [
                                  _createVNode("span", _hoisted_84, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cvcValue")), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("button", _hoisted_85, _toDisplayString(_ctx.t("startSection.createLinkPayForm.submit")), 1)
                    ])
                  ])
                ]),
                _createVNode(_Transition, null, {
                  default: _withCtx(() => [
                    _hoisted_86
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createVNode("span", _hoisted_89, _toDisplayString(_ctx.t("startSection.createLinkPayForm.way")), 1)
                ]),
                _hoisted_90
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}